/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M7.8177 12c.9964 0 1.8041-.8059 1.8041-1.8 0-.9941-.8077-1.8-1.804-1.8-.9964 0-1.8042.8059-1.8042 1.8 0 .9941.8078 1.8 1.8041 1.8ZM9.6218 19.2c.6643 0 1.2028-.5373 1.2028-1.2s-.5385-1.2-1.2028-1.2c-.6642 0-1.2027.5373-1.2027 1.2s.5385 1.2 1.2027 1.2ZM16.8382 15.6c0 .6627-.5385 1.2-1.2027 1.2-.6643 0-1.2028-.5373-1.2028-1.2s.5385-1.2 1.2028-1.2c.6642 0 1.2027.5373 1.2027 1.2Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.0273 0c-.6764 0-1.3396.0557-1.9855.1627C4.3441 1.1071 0 6.0474 0 12c0 6.6274 5.3848 12 12.0273 12 5.5328 0 10.1931-3.7275 11.5957-8.8028A11.9319 11.9319 0 0 0 24 13.1505a3.0311 3.0311 0 0 1-.5468.0495 3.005 3.005 0 0 1-1.0956-.2054 3.0147 3.0147 0 0 1-1.4049-1.128 2.978 2.978 0 0 1-.4927-1.3787 5.413 5.413 0 0 1-1.9826.3096C15.5646 10.7106 13.23 8.3273 13.23 5.4c0-.7555.1555-1.4748.4363-2.1277-.8057-.4113-1.401-1.1748-1.5818-2.087A3.0106 3.0106 0 0 1 12.0273.6c0-.2054.0207-.406.0601-.5999L12.0273 0Zm7.134 12.7821a5.0239 5.0239 0 0 0 2.473 2.0785C20.4015 18.9889 16.5659 22 12.0273 22 6.4919 22 2.0045 17.5228 2.0045 12c0-4.9245 3.5677-9.0176 8.2649-9.8467a4.996 4.996 0 0 0 1.0893 1.8452A7.4114 7.4114 0 0 0 11.2255 5.4c0 4.087 3.3206 7.4 7.4168 7.4.1743 0 .3474-.006.519-.0179Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.2437 1.8c0 .9941-.8078 1.8-1.8041 1.8-.9964 0-1.8041-.8059-1.8041-1.8 0-.9941.8077-1.8 1.8041-1.8.9963 0 1.8041.8059 1.8041 1.8ZM21.6491 8.4c.6643 0 1.2027-.5373 1.2027-1.2S22.3134 6 21.6491 6c-.6642 0-1.2027.5373-1.2027 1.2s.5385 1.2 1.2027 1.2Z"
    />
  </React.Fragment>,
  'MenuCookie'
);
